module.exports = __webpack_public_path__ + "img/ok.7f61e900.svg";